module.exports = __webpack_public_path__ + "img/y_2022_hover.e6520855.png";